import React from "react";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import qs from "qs";

import { AuthContext } from "@contexts/auth";

import { IAuthContext, TLoginData } from "@types";
import { useNavigation, useRouterContext, useNotification } from "@hooks";

export const useLogin = <TVariables = {}>(): UseMutationResult<
  TLoginData,
  Error,
  TVariables,
  unknown
> => {
  const { replace } = useNavigation();
  const { login: loginFromContext } =
    React.useContext<IAuthContext>(AuthContext);

  const { useLocation } = useRouterContext();
  const { search } = useLocation();
  const { close, open } = useNotification();

  const { to } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  const queryResponse = useMutation<TLoginData, Error, TVariables, unknown>(
    ["useLogin"],
    loginFromContext,
    {
      onSuccess: (redirectPathFromAuth) => {
        if (to) {
          return replace(to as string);
        }

        if (redirectPathFromAuth !== false) {
          if (typeof redirectPathFromAuth === "string") {
            replace(redirectPathFromAuth);
          } else {
            replace("/");
          }
        }
        close?.("login-error");
      },
      onError: (error: any) => {
        open?.({
          message: error?.name || "Login Error",
          description: error?.message || "Invalid credentials",
          key: "login-error",
          type: "error",
        });
      },
    }
  );

  return queryResponse;
};
